import ChannelsV2 from './ChannelsV2'
export default ChannelsV2
